import React, { useEffect, useState } from "react";
import Moment from "moment";
import DataTable from "../../../Table/DataTable";
import { Add as AddIcon } from "@mui/icons-material";
import { Link, useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../../../services";
import { ToastManager } from "../../../common/ToastContainer";
import FullPageProgress from "../../../common/FullPageProgress";
import { SESSION_AUTH } from "../../../../helpers/auth";
import { getModuleAllPermissions } from "../../../../helpers/utils";
import AddNewParticipant from "../../EventAttende/AddNewParticipant";

const EventListParticipant = (props) => {
  const { module } = props;
  const [loader, setLoader] = useState(false);
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [userData, setUserData] = useState("");
  const [eventList, setEventList] = useState([]);
  const { eventId } = useParams();
  const [dataFetched, setDataFetched] = useState(false);
  const [modulePermissions, setModulePermissions] = useState("");
  const [addParticipant, setAddParticipant] = useState(false);

  useEffect(() => {
    if (userSession) {
      setUserData(userSession);
    } else {
      setUserData("");
    }
    return () => null;
  }, [userSession]);

  useEffect(() => {
    if (userSession) {
      setModulePermissions(getModuleAllPermissions(userSession, module));
      setUserData(userSession);
    } else {
      setModulePermissions("");
      setUserData("");
    }
    return () => null;
  }, [userSession, module]);

  useEffect(() => {
    if (!userData || dataFetched) return;

    setLoader(true);
    setDataFetched(true);

    let parma = { eventId: eventId, userId: userData.userId };

    EVENTS_SERVICES.getEventsParticipants(parma)
      .then((data) => {
        setEventList([]);
        if (data.code === 200) {
          setEventList(data?.data || []);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [userData, dataFetched, LOGOUT_USER_SESSION, eventId]);

  const columns = [
    {
      name: "sno",
      label: "S.No.",
    },

    {
      name: "user",
      label: "User",
      options: {
        customBodyRender: (value) => {
          return (
            <Link
              className="text-link"
              to={`/events/users/${value?.userId}/profile`}
              target="_blank"
            >
              {value?.name}
            </Link>
          );
        },
      },
    },

    {
      name: "createdAt",
      label: "Register Date",
    },
    {
      name: "attendDate",
      label: "Attended Date",
    },
  ];

  const customOption = {
    pagination: false,
  };

  return (
    <>
      {modulePermissions?.add ? (
        <>
          <div
            className="managepro6ix-layout-page-content-header"
            style={{ paddingTop: "0px" }}
          >
            <div className="managepro6ix-layout-page-content-header-action">
              <button
                type="button"
                onClick={() => {
                  setAddParticipant(true);
                }}
                className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
              >
                <AddIcon /> Add Participant
              </button>
            </div>
          </div>
          {addParticipant && (
            <AddNewParticipant
              module={module}
              open={addParticipant}
              eventId={eventId}
              onClose={() => {
                setAddParticipant(false);
              }}
              onUpdate={() => {
                setAddParticipant(false);
                setDataFetched(false);
              }}
            />
          )}
        </>
      ) : null}

      {loader && <FullPageProgress />}

      <DataTable
        columns={columns}
        customOption={customOption}
        data={eventList.map((item, key) => {
          return {
            sno: key + 1,
            eventType: item,
            user: { name: item?.name, userId: item?.userId },
            createdAt: item?.date
              ? Moment(item?.date).format("MMM DD, YYYY : hh:mm A")
              : "-",
            attendDate: item?.attendDate
              ? Moment(item?.attendDate).format("MMM DD, YYYY : hh:mm A")
              : "-",
          };
        })}
      />
    </>
  );
};

export default EventListParticipant;
